<template>
  <v-container fluid class="overflow-container pt-0" style="height:calc(100vh - 65px);">
    <v-row align="center" dense class="filtros-sticky">
      <v-col class="d-flex" cols="12" sm="3">
        <v-select v-model="semestre" hide-details @change="selectSemestre" :items="semestres"
          label="Filtre por Semestre" item-value="Id" item-text="Nombre" return-object />
      </v-col>
      <v-col class="d-flex" cols="12" sm="1">
        <v-select v-model="modalidad" hide-details @change="selectSemestre" :items="modalidades" label="Modalidad" />
      </v-col>
      <v-col class="d-flex" cols="12" sm="2">
        <v-select v-model="sede" hide-details @change="filterByCarrera" :items="sedes" label="Filtre por Sede"
          clearable />
      </v-col>
      <v-col class="d-flex" cols="12" sm="2">
        <v-select v-model="carrera" hide-details @change="filterByCarrera" :items="carreras" label="Filtre por Carrera"
          clearable />
      </v-col>
      <v-col class="d-flex" cols="12" sm="2">
        <v-switch label="Ocultar A Designar" v-model="ocultarADesignar"></v-switch>
      </v-col>
      <!-- <v-spacer></v-spacer>
      <v-col cols="12" md="3" right>
        <v-spacer></v-spacer>
        <v-btn :loading="lgExcel" color="green" dark @click="descargarExcel">
          <v-icon left>mdi-download</v-icon>
          Descargar Planificación
        </v-btn>
      </v-col> -->
    </v-row>

    <v-row>
      <v-col>
        <table style="border: 1px solid; width: 100%;">
          <thead>
            <tr>
              <th></th>
              <th style="border: 1px solid;" v-for="(anio) in cronograma" :key="anio.Año" :colspan="anio.Grupos.length">
                {{ anio.Año }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <template v-for="item in cronograma">
                <td v-for="(grupo, igrupo) in item.Grupos" :key="igrupo + grupo.Nombre"
                  style="border: 1px solid; text-align: center;">
                  {{ grupo.Nombre }}
                </td>
              </template>
            </tr>
            <tr>
              <td></td>
              <template v-for="(item) in cronograma">
                <td v-for="(grupo, iGrupo) in item.Grupos" style="border: 1px solid;vertical-align: top; "
                  :key="iGrupo + grupo.Nombre">
                  <div v-for="(md, iAsig) in grupo.Asignaturas" :key="md.ComisionPlanificacionId"
                    style="height: 73px; padding-left: 5px; font-size: 10px;"
                    :style="{ backgroundColor: getColorByIndex(iAsig).background, color: getColorByIndex(iAsig).text, display: (md.DocenteId == 1 && ocultarADesignar) ? 'none' : '' }"
                    @click="openDialog(md)">
                    <b>{{ md.Asignatura }}</b>
                    <br>
                    <v-row dense class="d-flex justify-space-between ml-0 mr-1">
                      <span>
                        {{ md.Cantidad - md.Faltante }} de {{ md.Cantidad }} {{ md.horario ? ' | ' + md.horario : (!md.tutorias ? '' : ' | ' + md.tutorias[0].hora.substring(0, 5)) }}
                      </span>
                      <v-icon v-if="md.Cantidad - md.Faltante == 0" color="red" small>mdi-alert-circle</v-icon>
                      <v-icon v-else-if="md.Cantidad - md.Faltante < md.Cantidad" color="orange"
                        small>mdi-alert-circle</v-icon>
                    </v-row>
                    <span>
                      {{ md.Docentes }}
                    </span>
                  </div>
                </td>
              </template>
            </tr>
            <tr v-for="(month, indexMonth) in months" :key="indexMonth" v-if="cronograma">
              <td>{{ month }}</td>
              <template v-for="(item, index) in cronograma">
                <td v-for="(grupo) in item.Grupos" style="border: 1px solid; vertical-align: top">
                  <table class="calendar-table">
                    <thead>
                      <tr>
                        <th v-for="(weekday, indexDay) in weekdays" :key="'weekday-' + indexDay"
                          @click="openDialogDiaSemana(indexDay, weekday, grupo)">{{ weekday }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(week, weekIndex) in getWeeksInMonth(indexMonth, selectedYear)"
                        :key="'week-' + weekIndex">

                        <td v-for="(day, dayIndex) in week" :key="dayIndex" class="day-cell"
                          @click="openDialogDia(day, grupo)">
                          <div class="segments">
                            <div v-for="(seg, i) in getTutoriasSegments(day, grupo)" :key="i" class="segment"
                              :style="{ backgroundColor: seg.background, color: seg.text }" />
                          </div>

                          <span class="day-label">{{ day ? day.split('-')[2] : '' }}</span>
                        </td>



                        <!-- <td v-for="(day, dayIndex) in week" :key="dayIndex" @click="openDialogDia(day, grupo)" 
                        :style="{
                          ///border: '2px solid green',
                          backgroundColor: isTutoria(day, grupo).background || 'transparent',
                          color: isTutoria(day, grupo).text || 'black'
                        }">
                          {{ day ? day.split('-')[2] : '' }}
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                  <!-- :style="{ backgroundColor: isTutoria(day, grupo) || 'transparent', color: isTutoria(day, grupo) ? 'white' : 'black' }" -->
                </td>
              </template>
            </tr>
          </tbody>
        </table>

        <!-- Diálogo -->
        <v-dialog v-model="dialog" max-width="900px">
          <v-card>
            <v-card-title>Detalles de {{ asignatura.Asignatura }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <p><strong>Comision:</strong> {{ asignatura.NombreComision }}</p>
                  <p><strong>Docentes:</strong> {{ asignatura.Docentes }}</p>
                  <p><strong>Cantidad de encuentros:</strong> {{ asignatura.Cantidad }}</p>
                  <p><strong>Horario:</strong> {{ asignatura.horario }}</p>
                  <p v-if="asignatura.Faltante != 0">
                    <strong>Faltantes:</strong> {{ asignatura.Faltante }}
                  </p>
                  <div v-if="asignatura.tutorias && asignatura.tutorias.length > 0">
                    <strong>Tutorías:</strong>
                    <ul>
                      <li v-for="(tutoria, index) in asignatura.tutorias" :key="index">
                        {{ formatTutoriaDate(tutoria.fecha) }} {{ tutoria.hora }}
                      </li>
                    </ul>
                  </div>
                </v-col>
                <v-col cols="6">

                  <v-row>
                    <strong>Disponibilidad Docente</strong>
                    <v-spacer></v-spacer>
                    <v-btn color="success" x-small @click="  dgDisponibilidad = true">Agregar</v-btn>
                  </v-row>


                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Dia</th>
                          <th class="text-left">Horario</th>
                          <th class="text-left">Modalidad</th>
                          <th class="text-left">Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in asignatura.Disponibilidad" :key="index">
                          <td>{{ item.dia }}</td>
                          <td>{{ item.hora }}</td>
                          <td>{{ item.Modalidad }}</td>
                          <td>
                            <!-- <v-chip :color="item.Libre ? 'blue' : 'orange'" dark x-small outlined
                      @click="planificarAqui(item.disponibilidadId)">
                      {{ item.Libre ? "Planificar aquí!" : "Replanificar" }}
                    </v-chip> -->
                            <v-chip :color="item.Libre ? 'blue' : 'orange'" dark x-small outlined
                              @click.stop="planificarAqui(item.disponibilidadId)">
                              {{ item.Libre ? "Planificar aquí!" : "Replanificar" }}
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="dialog = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dgDisponibilidad" scrollable max-width="500px" transition="dialog-transition">
          <v-card>
            <v-card-title>Cargar disponibilidad</v-card-title>
            <v-card-text>
              <VDisponibilidad ref="dispo"></VDisponibilidad>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="dgDisponibilidad = false">Cerrar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="cargarDisponibilidad" :loading="loadingDispo">Guardar</v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <v-dialog v-model="dgAsignaturas" v-if="dgAsignaturas" max-width="500px" transition="dialog-transition"
          persistent>

          <v-card>
            <v-card-title>Asignaturas {{ formatTutoriaDate(diaSeleccionado) }} </v-card-title>
            <v-card-text>
              <v-list dense>
                <v-list-item-group v-model="selectAsignatura" color="primary">
                  <v-list-item v-for="(item, i) in asignaturas" :key="i" @click.stop="modificarTutoria(item)">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.Asignatura"></v-list-item-title>
                      <v-list-item-subtitle v-html="item.NombreComision"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="item.Docentes"></v-list-item-subtitle>
                      <v-list-item-subtitle v-html="item.horario"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon v-if="item.isDelTuto" color="red">mdi-delete-circle</v-icon>
                      <v-icon v-else color="green">mdi-plus-circle</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="cerrarDgAsignaturas">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PlanificadorService from "../services/Planificador.service"
import VDisponibilidad from "../components/planificacdor/Disponifilidad.vue"
export default {
  components: {
    VDisponibilidad
  },
  data() {
    return {
      ocultarADesignar: false,
      lgExcel: false,
      dgDisponibilidad: false,
      dgAsignaturas: false,
      diaSeleccionado: '',
      indexdiaSeleccionado: -1,
      carrera: '',
      selectAsignatura: null,
      sede: '',
      dialog: false,
      loadingDispo: false,
      asignatura: {},
      asignaturas: [],
      cronograma: null,
      tutoTemp: null,
      semestre: null,
      semestres: this.$store.semestres,
      noLaborales: [],
      cronogramaOri: [
      ],
      colores: [
        { background: "#AE81EF", text: "black" }, // Amarillo
        { background: "#8299ED", text: "black" }, // Rojo
        { background: "#82CFED", text: "black" }, // Azul
        { background: "#82EDD6", text: "black" }, // Verde
        { background: "#E681EF", text: "white" }, // Morado
      ],
      selectedYear: 2025,
      weekdays: ["L", "M", "M", "J", "V", "S", "D"],
      strDias: ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sadabo", "D"],
      type: 'month',
      value: '',
      mode: 'stack',
      weekday: [1, 2, 3, 4, 5, 6],
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      modalidades: this.$store.modalidades,
      modalidad: 'S',
    };
  },
  computed: {
    months() {
      if (!this.semestre) return;
      if (this.semestre.periodo === 1)
        return [
          'Marzo', 'Abril', 'Mayo', 'Junio'

        ];
      if (this.semestre.periodo === 2)
        return [
          'Agosto', 'Septiembre', 'Octubre', 'Noviembre'
        ];
    },
    carreras() {
      // Extrae las carreras únicas de los grupos
      const allCarreras = new Set();
      this.cronogramaOri.forEach(año => {
        año.Grupos.forEach(grupo => {
          allCarreras.add(grupo.Carrera);
        });
      });
      return Array.from(allCarreras);
    },
    sedes() {
      // Extrae las carreras únicas de los grupos
      const allSede = new Set();
      this.cronogramaOri.forEach(año => {
        año.Grupos.forEach(grupo => {
          allSede.add(grupo.sede);
        });
      });
      return Array.from(allSede);
    }
  },
  mounted() {
    //getEvents();
    this.getCarrera();
  },
  methods: {
    getTutoriasSegments(day, grupo) {
      if (!day) return [{ background: "transparent", text: "black" }];

      if (this.isNoLaborable(day)) {
        return [{ background: "#FA8F8F", text: "white" }];
      }

      const asigs = (grupo && grupo.Asignaturas) ? grupo.Asignaturas : [];
      const matches = [];

      let i = 0;
      for (const asig of asigs) {
        if (asig.tutorias && asig.tutorias.some(t => t.fecha === day)) {
          matches.push(this.getColorByIndex(i));
        }
        i++;
      }

      if (matches.length === 0) {
        return [{ background: "transparent", text: "black" }];
      }

      // por ahora 2 capas máximo
      return matches.slice(0, 2);
    },
    async descargarExcel() {
      this.lgExcel = true; // Activar el indicador de carga
      PlanificadorService.DescargarPlanificacion(document).then((result) => {
        try {
          // Crear un enlace para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;
          // Definir el nombre del archivo
          link.setAttribute("download", "ReportePlanificacion.xlsx");
          // Agregar el enlace al DOM y hacer clic en él
          document.body.appendChild(link);
          link.click();
          // Limpiar el enlace del DOM
          link.remove();
          this.lgExcel = false; // Desactivar el indicador de carga
        } catch (error) {
          this.$toast.error("Error al descargar el archivo Excel");
        }
      }).catch((err) => {
        this.$toast.error("Error al descargar el archivo Excel");
        this.lgExcel = false; // Desactivar el indicador de carga
      });
    },
    cerrarDgAsignaturas() {
      this.diaSeleccionado = '';
      this.indexdiaSeleccionado = -1;
      this.asignaturas = [];
      this.dgAsignaturas = false;
    },
    async cargarDisponibilidad() {
      if (!this.$refs.dispo.dia || !this.$refs.dispo.horario || this.$refs.modalidad) {
        return;
      }
      this.loadingDispo = true;
      let dia = { ...this.$refs.dispo.dia };
      dia.horario = this.$refs.dispo.horario;
      dia.docenteId = this.asignatura.DocenteId;
      dia.modalidad = this.$refs.dispo.modalidad.modalidad;
      let disponibilidad = dia;
      PlanificadorService.AgregarDisponibilidad(disponibilidad).then(
        res => {
          this.loadingDispo = false;
          this.$refs.dispo.dia = null;
          this.$refs.dispo.horario = null;
          this.$refs.dispo.modalidad = null;
          this.asignatura.Disponibilidad = res.data;
          this.$toast.success("Registro cargado.");
        }).catch(err => {
          this.loadingDispo = false;
          this.$toast.error(err.response.data);
        });
    },
    planificarAqui(disponibilidadId) {
      PlanificadorService.PlanificaiconParcial(this.asignatura.ComisionPlanificacionId, disponibilidadId).then((result) => {
        this.asignatura.tutorias = result.data;
        this.asignatura.Faltante = this.Cantidad - this.asignatura.tutorias.length;
      }).catch((err) => {
        this.$toast.error(err.response.data);
      });
    },
    filterByCarrera() {
      if (this.carrera || this.sede) {
        this.cronograma = this.cronogramaOri.map(año => {
          return {
            ...año,
            Grupos: año.Grupos.filter(grupo =>
              (!this.carrera || grupo.Carrera === this.carrera) &&
              (!this.sede || grupo.sede === this.sede))
          };
        }).filter(año => año.Grupos.length > 0);
      } else {
        this.cronograma = this.cronogramaOri; // Muestra todos si no se selecciona ninguna carrera
      }
    },
    openDialog(asignatura) {
      this.asignatura = asignatura;
      this.dialog = true;
    },
    openDialogDiaSemana(index, daySemana, grupo) {
      for (const materia of grupo.Asignaturas) {
        // Verifica si el día está en las tutorías de la asignatura
        if (!materia.tutorias) {
          this.asignaturas.push(materia);
          materia.isDelTuto = false;
        }
        this.diaSeleccionado = this.strDias[index];
        this.indexdiaSeleccionado = index;
        if (this.asignaturas.length > 0) {
          this.dgAsignaturas = true;
        }
      }
    },
    openDialogDia(day, grupo) {
      if (this.isNoLaborable(day)) {
        this.$toast.warning("Dia no laborable! o es posible planificar")
        return;
      }
      this.asignaturas = [];
      this.diaSeleccionado = day;
      for (const materia of grupo.Asignaturas) {
        // Verifica si el día está en las tutorías de la asignatura
        if (materia.tutorias && materia.tutorias.some(tutoria => tutoria.fecha === day)) {
          const tutoria = materia.tutorias.find(t => t.fecha === day);
          // Devuelve el color asociado a la asignatura
          materia.tutoriaId = tutoria.tutoriaId;
          materia.isDelTuto = true;
        } else {
          materia.isDelTuto = false;
        }
        this.asignaturas.push(materia);
      }
      if (this.asignaturas.length > 0) {
        this.dgAsignaturas = true;
      }
    },
    modificarTutoria(comision) {

      if (comision.DocenteId == 1 && this.indexdiaSeleccionado != -1) {

        //this.asignatura= comision;
        PlanificadorService.PlanificaiconParcial(comision.ComisionPlanificacionId, this.indexdiaSeleccionado).then(async (result) => {
          //this.asignatura.tutorias = result.data;
          //this.asignatura.Faltante = this.Cantidad - this.asignatura.tutorias.length;
          await this.getCarrera();
          this.filterByCarrera();
          this.$toast.success("Tutoria agregada!");
          this.cerrarDgAsignaturas();
        }).catch((err) => {
          this.$toast.error(err.response.data);
        });



      } else {
        if (comision.isDelTuto) {
          PlanificadorService.BorrarTutoria(comision.ComisionPlanificacionId, comision.tutoriaId, this.diaSeleccionado).then(async (result) => {
            if (result.data.fusion) {
              await this.getCarrera();
              this.filterByCarrera();
              this.$toast.success("Tutorias Eliminadas!");
            } else {
              for (const asignatura of this.asignaturas) {
                // Buscar el índice de la tutoria dentro del array tutorias
                const index = asignatura.tutorias.findIndex(t => t.tutoriaId === comision.tutoriaId);
                if (index !== -1) {
                  // Eliminar la tutoria si se encuentra
                  asignatura.tutorias.splice(index, 1);
                  this.$toast.success("Tutoria eliminada");
                  break; // Salir del bucle si se encuentra y elimina
                }
              }
            }
            this.cerrarDgAsignaturas();
          }).catch((err) => {
            this.$toast.error(err.response.data);
          });
        } else {
          PlanificadorService.AgregarTutoria(comision.ComisionPlanificacionId, this.diaSeleccionado).then(async (result) => {
            await this.getCarrera();
            this.filterByCarrera();
            this.$toast.success("Tutoria agregada!");
            this.cerrarDgAsignaturas();

            // this.tutoTemp = { ...result.data };
            //for (const asignatura of this.asignaturas) {
            //  // Buscar la asignatura para agregar tutoria
            //  if (asignatura.ComisionPlanificacionId === comision.ComisionPlanificacionId) {
            //    // Agregar la tutoria
            //    asignatura.tutorias.push(this.tutoTemp);
            //    this.cerrarDgAsignaturas();
            //    this.$toast.success("Tutoria agregada");
            //    break; // Salir del bucle si se encuentra y elimina
            //  }
            //} 
          }).catch((err) => {
            this.$toast.error(err.response.data);
          });
        }
      }
    },
    formatTutoriaDate(dateString) {
      try {
        const date = new Date(dateString + "T00:00:00");
        const formatter = new Intl.DateTimeFormat("es-ES", {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        });
        return " del " + formatter.format(date).replace(",", "");
      } catch (error) {
        return "para los dias " + this.diaSeleccionado
      }

    },
    selectSemestre() {
      this.selectedYear = this.semestre.año;
      this.getCarrera();
    },
    async getCarrera() {
      if (!this.semestre) return;
      if (!this.modalidad) return;
      this.cronogramaOri = [];
      this.cronograma = [];
      let responseNL = await PlanificadorService.ObtenerTodo(this.selectedYear);
      this.noLaborales = new Set(responseNL.data);;
      let response = await PlanificadorService.ObtenerCarreraAnio(this.modalidad, this.semestre.Id);
      this.cronogramaOri = response.data;
      this.cronograma = response.data;

      /*var contador=0;
      this.cronograma.forEach(element => {
        for (const grupo of element.Grupos) {
          contador += !grupo.Asignaturas?0:grupo.Asignaturas.length;
        }
      });
      console.log(contador); */
      this.filterByCarrera();
    },
    getColorByIndex(index) {

      // Devuelve el color correspondiente según el índice
      return this.colores[index % this.colores.length];
    },
    isTutoria(day, grupo) {
      //console.log(day, grupo);
      if (this.isNoLaborable(day)) return { background: "#FA8F8F", text: "white" };
      if (!grupo.Asignaturas) return { background: "transparent", text: "black" };
      var i = 0;
      for (const grupo of grupo.Asignaturas) {
        // Verifica si el día está en las tutorías de la asignatura
        if (grupo.tutorias && grupo.tutorias.some(tutoria => tutoria.fecha === day)) {
          // Devuelve el color asociado a la asignatura
          return this.getColorByIndex(i); // Usa un color por defecto si no hay color
        }
        i++;
      }
      return { background: "transparent", text: "black" };
    },
    isNoLaborable(day) {
      if (!day) return false;
      const dia = day.includes("T") ? day : `${day}T00:00:00`;
      return this.noLaborales.has(dia);//? { background: "gray", text: "black" } : {background: "transparent", text: "black"};
    },
    getWeeksInMonth(month, year) {
      if (this.semestre.periodo === 1) {
        month = month + 3;
      } else {
        month = month + 8;
      }
      const firstDay = new Date(year, month - 1, 1);
      const lastDay = new Date(year, month, 0);
      const weeks = [];
      let currentWeek = Array(7).fill(null);

      // Ajustar índice para que la semana inicie en lunes
      let startIndex = (firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1);

      // Rellenar días iniciales
      for (let i = 0; i < startIndex; i++) {
        currentWeek[i] = null;
      }

      // Rellenar días del mes
      for (let day = 1; day <= lastDay.getDate(); day++) {
        const date = new Date(year, month - 1, day);
        const adjustedDay = (date.getDay() === 0 ? 6 : date.getDay() - 1);
        currentWeek[adjustedDay] = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

        // Si es domingo (final de la semana) o último día del mes, cerrar la semana
        if (adjustedDay === 6 || day === lastDay.getDate()) {
          weeks.push(currentWeek);
          currentWeek = Array(7).fill(null);
        }
      }

      return weeks;
    },
    dayStyle({ day }) {
      return {
        class: 'custom-day'
      };
    }
  }
};

/*
<v-card>
      <v-card-title>Calendario Anual</v-card-title>
      <v-card-text>
        <v-row>
          <v-col v-for="(month, index) in months" :key="index" cols="12" sm="6" md="4" lg="4">
            <v-card>
              <v-card-title>{{ month }}</v-card-title>
              <v-card-text>
                <v-calendar ref="calendar[month]" :key="month"
                  :start="getDaysInMonth(month, year).toISOString().split('T')[0]" :weekdays="weekday" :type="type"
                  :event-overlap-mode="mode" :event-overlap-threshold="30" @change="getEvents" :events="events">
                  <!-- :now="getDaysInMonth(month, year).toISOString().split('T')[0]"  -->
                  <!-- :event-color="getEventColor" -->
                  <!-- @change="getEvents" -->
                  <!-- :events="events" -->
                  <!-- :now="new Date()" -->
                </v-calendar>
                <!--  <v-list dense>
                <v-list-item
                v-for="(day, dayIndex) in getDaysInMonth(index + 1, year)"
                :key="dayIndex"
                :class="{ 'has-event': hasEvent(day,month) }"
                @click="showEvent(day)"
                >
                <v-list-item-title>{{ day }}</v-list-item-title>
              </v-list-item>
            </v-list> -->
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
*/
</script>

<style>
/* Estilos globales para evitar overflow en el HTML */
html {
  overflow: hidden !important;
}
.day-cell {
  position: relative;
  padding: 0;
}

.segments {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
}

.segment {
  flex: 1;
}

.day-label {
  position: relative;
  z-index: 1;
  display: block;
  text-align: center;
  line-height: 22px; /* ajustá al alto real de tu fila */
}

.filtros-sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 20;
  background: white;
  padding-top: 6px;
  padding-bottom: 6px;
}

/* Estilos específicos para el contenedor con overflow activado */
.overflow-container {
  overflow-x: auto;
  overflow-y: auto;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

.calendar-table th,
.calendar-table td {
  border: 1px solid #ddd;
  width: 14.2%;
  padding: 3px;
  /* 7 columnas */
  height: 22px !important;
  cursor: pointer;
  vertical-align: top;
}

.calendar-table td.empty {
  background-color: #f5f5f5;
  cursor: default;
}

.calendar-table td:hover {
  background-color: #cce5ff;
}

.calendar-table td.disabled {
  background-color: #f8d7da;
  color: #721c24;
}

.custom-day {
  background-color: red;
  /* Cambia el color de fondo aquí */
  border: 1px solid black;
  /* Puedes añadir bordes si lo deseas */
  padding: 5px;
  box-sizing: border-box;
}
</style>